export const Fonts = {
  POPPINS: 'font-family: Poppins, sans-serif',
  GOTHIC: 'font-family: Gothic A1, sans-serif',
  MONTSERRAT: 'font-family: Montserrat, sans-serif',
  LATO: 'font-family: Lato, sans-serif',
  GOTHIC_ELLIPSIS_WORKAROUND: 'font-family: Ellipsis, Gothic A1, sans-serif',
};
